module.exports = __webpack_public_path__ + "img/04-burger-inn.c85c5259.jpg";